





















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getDropdown, trackSubmit } from '@/api/track/index'
import { AppModule } from '@/store/modules/app'
@Component({
  name: 'createOrder',
  components: {

  }
})
export default class extends Vue {
  get lang() {
    return AppModule.language.toString()
  }

  @Prop({ required: true }) private visible!: string
  @Prop({ required: true }) private detail!: any
  @Prop({ required: true }) private multipleSelection!: any

  @Watch('detail', { deep: true, immediate: true })
  private onWatchChange() {
    console.log('this.detail', this.detail)
    if (this.detail) {
      this.form = {
        code: this.detail.orders_code,
        code_type: 'orders_code',
        nodeType: '1',
        tsc_rules: this.detail.tsc_rules.split(',')
      }
      console.log('this.form', this.form)
      if (!this.detail.tsc_rules) {
        this.form.nodeType = '2'
      } else {
        this.form.nodeType = '1'
      }
    } else if (this.multipleSelection && this.multipleSelection.length) {
      this.form = {
        code: this.multipleSelection.map((item:any) => item.orders_code),
        code_type: 'orders_code',
        nodeType: '1',
        tsc_rules: []
      }
    }
  }

  private form = {
    code: '',
    code_type: 'orders_code',
    nodeType: '1',
    tsc_rules: []
  }

  private rules = {
    code: [
      { required: true, message: '请输入完整', trigger: 'change' }
    ],
    tsc_rules: [
      {
        required: true,
        validator: (rule:any, value:any, callback:any) => {
          const nodeType = this.form.nodeType
          console.log('nodeType', nodeType)
          if (nodeType === '1' && value.length === 0) {
            callback(new Error('请选择订阅节点'))
          } else {
            callback()
          }
        },
        trigger: 'change'
      }
    ]
  }

  // private nodeType:any = '1'
  handleNodeTypeChange(val:any) {
    console.log('val', val);
    (this.$refs.ruleForm as any).clearValidate()
    // this.form.nodeType = val
  }

  private codeTypeList:any = [
    {
      label: '物流订单号',
      value: 'orders_code'
    },
    {
      label: 'AE订单号',
      value: 'ae_code'
    },
    {
      label: '跟踪号',
      value: 'tracking_number'
    },
    {
      label: '客户参考号',
      value: 'customer_order_code'
    }
  ]

  handleInpChange(val:any) {
    // 按换行分割成数组
    const lines = val.split('\n')

    // 去除空行并去掉每行的首尾空白
    const cleanedLines = lines.map((line:any) => line.trim()).filter((line:any) => line !== '')

    // 用逗号拼接起来
    this.form.code = cleanedLines.join(',')
  }

  private tscRulesList:any = []
  handleCancel() {
    this.$emit('close')
  }

  handleConfirm() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        const obj = {
          tsc_id: this.detail ? this.detail.tsc_id : (this.multipleSelection && this.multipleSelection.length ? this.multipleSelection.map((item:any) => item.tsc_id).join(',') : undefined),
          code: (this.detail || (this.multipleSelection && this.multipleSelection.length)) ? undefined : this.form.code,
          code_type: (this.detail || (this.multipleSelection && this.multipleSelection.length)) ? undefined : this.form.code_type,
          tsc_type: '2',
          tsc_rules: this.form.nodeType === '1' ? this.form.tsc_rules.join(',') : ''
        }
        trackSubmit(obj).then(() => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.$emit('close')
        })
      } else {
        return false
      }
    })
  }

  handleGetDropdown() {
    getDropdown({
      type: ['tsc_rules']
    }).then((res) => {
      this.tscRulesList = Object.entries(res.data.tsc_rules).map(([key, value]) => ({ key: String(key), value }))
    })
  }

  created() {
    this.handleGetDropdown()
  }

  handleClose() {
    this.$emit('close')
  }
}
